/**
 * Identifier for the type of error causing the failure.
 *
 * @public
 */
export var ErrorType;
(function (ErrorType) {
    /** A timeout error from the server. */
    ErrorType["Timeout"] = "TIMEOUT";
    /** An internal error from the API backend. */
    ErrorType["BackendError"] = "BACKEND_ERROR";
    /** An invalid config from the request. */
    ErrorType["InvalidConfig"] = "INVALID_CONFIG";
    /** An invalid query from the request. */
    ErrorType["InvalidQuery"] = "INVALID_QUERY";
})(ErrorType || (ErrorType = {}));
//# sourceMappingURL=ErrorType.js.map